import React, { memo, useMemo } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, CardBody, Col } from "reactstrap"

const DiscountType = ({
  type = '',
  range = 0,
  title = '',
  colSize = 3,
  store_details = {},
  store_domain = "",
  store_status = "",
  is_campaign = false,
  is_selector = false
}) => {
  const editLinkProps = useMemo(() => {
    const baseProps = {
      search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined,
      state: { data: { store_domain, store_details, store_status } }
    };

    if (is_campaign) {
      return {
        pathname: "/campaign-metafields-edit",
        ...baseProps
      };
    }

    if (is_selector) {
      return {
        pathname: "/price-selector-edit",
        ...baseProps
      };
    }

    return {
      pathname: "/discount-type-edit",
      ...baseProps,
      state: {
        data: {
          store_domain,
          max_discount: range,
          type,
          store_details,
          store_status
        }
      }
    };
  }, [is_campaign, is_selector, store_domain, store_details, store_status, range, type]);

  return (
    <Col xl={colSize}>
      <Card>
        <CardBody>
          <div className="d-flex flex-wrap d-between-flex">
            <h3 className="card-title mb-3 me-2">{title}</h3>
            <Link to={editLinkProps}>
              <i className="fa fa-edit"></i> Edit
            </Link>
          </div>
          <div className="d-flex flex-wrap">
            <div>
              <h6 className="mb-3 text-primary"><i>{type}</i></h6>
              {type === 'Manual' && <h5 className="mb-0 mb">{range}px</h5>}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

DiscountType.propTypes = {
  type: PropTypes.string,
  range: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  colSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  store_details: PropTypes.object,
  store_domain: PropTypes.string,
  store_status: PropTypes.string,
  is_campaign: PropTypes.bool,
  is_selector: PropTypes.bool,
}

export default memo(DiscountType)
